import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ReceivableConsult,
  ReceivableConsultationPaged,
} from './models/receivable-api-model';
import { cleanEmptyProps } from '../../functions';

@Injectable({
  providedIn: 'root',
})
export class ReceivableService {
  private readonly API = `${environment.api_url}/Recebivel`;

  constructor(private http: HttpClient) {}

  getAllConsultation(filter: ReceivableConsult, paginator): Observable<ReceivableConsultationPaged> {
    return this.http.post<ReceivableConsultationPaged>(`${this.API}/consultar`, filter, {
      params: cleanEmptyProps(paginator)
    });
  }
}
